var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view'),_c('v-snackbar',{attrs:{"color":_vm.snackbarColor,"timeout":"2500"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.snackbarMessage))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }